module.exports = __webpack_public_path__ + "static/media/goals-light.f0d43976.svg";